import * as syncActions from './syncActions'
import { syncType as _syncType } from './syncTypes'

export const syncType = _syncType
export default syncActions
